import React, { useRef, useState } from "react";
import ListPesan2 from "../../components/ListPesan/ListPesan2";
import Slider from "react-slick";
import Box from "@mui/material/Box";
// import LCM7 from "../../assets/images/display/lcm-7.jpeg";
import LCM1 from "../../assets/images/display/lcm-1.jpg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./CustomerDisplay.css";
import Stack from "@mui/material/Stack";
import { ImageListItemProps } from "@mui/material";
import { CART_DISPLAY, DISPLAY_INFO } from "../../constants/common";
import { ICart, IDisplayInfo } from "../../constants/types";
import useBanner from "../../services/queries/useBanner";

type SliderImage = {
    id: string | number;
    src: string;
};

const IMAGES: SliderImage[] = [{ id: "fallback-0", src: LCM1 }];

const CustomerDisplay = () => {
    const ref = useRef<ImageListItemProps>(null);
    const { data: banners } = useBanner();
    const [cart, setCart] = useState<ICart[]>([]);
    const [displayInfo, setDisplayInfo] = useState<IDisplayInfo>({
        diskon: 0,
        kembalian: 0,
        pajak: 0,
        persentaseDiskon: 0,
        persentasePajak: 0,
        totalTagihan: 0,
        uangDibayar: 0,
    });

    const bannerImages: SliderImage[] = (banners ?? [])
        .filter((banner) => Boolean(banner.gambar))
        .map((banner) => ({
            id: banner.id,
            src: banner.gambar,
        }));

    const sliderImages = bannerImages.length > 0 ? bannerImages : IMAGES;

    window.onstorage = (event) => {
        if (event.key === CART_DISPLAY && event.newValue) {
            const sharedCart: ICart[] = JSON.parse(event.newValue);
            if (cart !== sharedCart) {
                setCart(sharedCart);
            }
        }
        if (event.key === DISPLAY_INFO && event.newValue) {
            const displayInfoShared: IDisplayInfo = JSON.parse(event.newValue);
            if (displayInfo !== displayInfoShared) {
                console.log("saved");
                setDisplayInfo(displayInfoShared);
            }
        }
    };

    return (
        <Stack direction="row" height="100vh">
            <Box height="100%" className="slider-container">
                {sliderImages.length > 1 ? (
                    <Slider
                        className="custom-slick"
                        infinite={true}
                        speed={500}
                        slidesToShow={1}
                        slidesToScroll={1}
                        autoplaySpeed={5000}
                        autoplay
                    >
                        {sliderImages.map((li, idx) => (
                            <Box
                                key={li.id?.toString() ?? idx.toString()}
                                component="img"
                                src={li.src}
                                alt="photo"
                                loading="lazy"
                                decoding="async"
                                width="100%"
                                height="100vh"
                                sx={{
                                    objectFit: "cover",
                                }}
                                ref={ref}
                            />
                        ))}
                    </Slider>
                ) : sliderImages.length === 1 ? (
                    <Box
                        component="img"
                        src={sliderImages[0].src}
                        alt="photo"
                        width="100%"
                        height="100vh"
                        sx={{
                            objectFit: "cover",
                        }}
                        ref={ref}
                    />
                ) : null}
            </Box>
            <Box
                height="100%"
                flex={1}
                sx={{
                    borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
                }}
            >
                <ListPesan2 cart={cart} displayInfo={displayInfo} />
            </Box>
        </Stack>
        // <Grid container>
        //     <Grid item xs={12} sm={12} md={5}>
        //         <Box height="100vh">
        //             <Box>
        //                 <Slider
        //                     className="custom-slick"
        //                     // dots
        //                     infinite={true}
        //                     speed={500}
        //                     slidesToShow={1}
        //                     slidesToScroll={1}
        //                     autoplaySpeed={5000}
        //                     autoplay
        //                 >
        //                     {IMAGES.map((li, idx) => (
        //                         <Box
        //                             key={idx.toString()}
        //                             component="img"
        //                             borderRadius={2}
        //                             src={li.src}
        //                             alt="photo"
        //                             width="100%"
        //                             height="calc(100vh - 6px)"
        //                             sx={{
        //                                 objectFit: "contain",
        //                             }}
        //                         />
        //                     ))}
        //                 </Slider>
        //                 {/* <Box
        //                     display="flex"
        //                     alignItems="center"
        //                     justifyContent="center"
        //                     gap={1}
        //                 >
        //                     <Typography variant="h6" color="white" fontWeight={600}>
        //                         Powered by ukmlokal.com
        //                     </Typography>
        //                 </Box> */}
        //             </Box>
        //         </Box>
        //     </Grid>
        //     <Grid
        //         id="barangPesanan"
        //         item
        //         xs={12}
        //         sm={12}
        //         md={7}
        //         sx={{
        //             borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        //             borderRight: "1px solid rgba(0, 0, 0, 0.12)",
        //         }}
        //     >
        //         <Box height="100vh">
        //             <ListPesan2 />
        //         </Box>
        //     </Grid>
        // </Grid>
    );
};
export default CustomerDisplay;
